module.exports = __webpack_public_path__ + "static/media/AoA_CloseUp_20.89830568.jpg";